import { useEffect } from "react";
import { Reveal, Overline } from "./Reveal";

const TALLY_SRC = "https://tally.so/r/BzONXR?transparentBackground=1&hideTitle=1&dynamicHeight=1";

export default function Rsvp() {
    useEffect(() => {
        if (!document.getElementById("tally-embed-script")) {
            const s = document.createElement("script");
            s.id = "tally-embed-script";
            s.src = "https://tally.so/widgets/embed.js";
            s.async = true;
            document.body.appendChild(s);
        }
    }, []);

    return (
        <section id="remerciements" data-testid="remerciements-section" className="relative bg-night-deep px-6 sm:px-12 lg:px-20 pt-28 sm:pt-36 pb-16 sm:pb-20">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-24 items-start">
                <Reveal>
                    <Overline>🎬 That's a wrap !</Overline>
                    <h2 className="mt-4 font-display text-4xl sm:text-5xl md:text-6xl tracking-tight leading-[1.02]">
                        Once Upon a Time<br /><em className="text-gold">in Hollywood.</em>
                    </h2>
                    <p className="mt-8 max-w-md text-base font-light leading-relaxed text-white/60">
                        Merci d'avoir fait partie de cette soirée exceptionnelle ! Le générique
                        est peut-être terminé, mais les souvenirs, eux, restent. Nous espérons
                        que vous avez passé une soirée inoubliable à nos côtés.
                    </p>
                    <p className="mt-6 max-w-md text-base font-light leading-relaxed text-white/60">
                        Si vous le souhaitez, laissez un petit mot à Lavinia et à ses parents
                        pour leur partager vos souvenirs, vos remerciements ou simplement
                        quelques mots qui leur feront plaisir.
                    </p>
                    <p className="mt-10 font-display text-xl italic text-gold/85">
                        Lights off. Memories on. ❤️
                    </p>
                </Reveal>

                <Reveal delay={0.12}>
                    <div className="relative">
                        <div
                            data-testid="tally-form-card"
                            className="relative border border-gold/20 overflow-hidden"
                        >
                            <iframe
                                data-testid="tally-form-iframe"
                                data-tally-src={TALLY_SRC}
                                width="100%"
                                frameBorder="0"
                                marginHeight="0"
                                marginWidth="0"
                                title="Remerciements — Once Upon a Time in Hollywood"
                                className="w-full max-w-full border-0 block h-[620px] lg:h-[710px] -mt-12"
                            />
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
